module.exports = __webpack_public_path__ + "img/empty-transing.6c9e88b4.svg";